












import { Vue, Component } from 'vue-property-decorator';
import { StudioActionUtil } from '@/utils';
import { Environment } from '@/environments/environment';
/**
 * 开发模式控制行为组
 *
 * @export
 * @class AppDebugActions
 * @extends {Vue}
 */
@Component({
})
export default class AppDebugActions extends Vue {

    /**
     * 是否显示
     *
     * @type {boolean}
     * @memberof AppDebugActions
     */
    public isShow:boolean = Environment.devMode;

    /**
     * 配置平台操作控制器
     *
     * @type {StudioActionController}
     * @memberof AppDebugActions
     */
    public sdc: StudioActionUtil = StudioActionUtil.getInstance();

}
